const SHARED_COOKIE_HOST = 'toogoodtogo.com';

/**
 * Only these production origins share one campaign cookie on toogoodtogo.com.
 * Staging, QA, dev, and every other host stay host-only so they cannot
 * overwrite production campaigns or referrers.
 */
const SHARED_PRODUCTION_ORIGINS = [
  'https://www.toogoodtogo.com',
  'https://business.toogoodtogo.com',
];

const SHARED_PRODUCTION_HOSTS = new Set(
  SHARED_PRODUCTION_ORIGINS.map((origin) => new URL(origin).hostname),
);

export function usesLiveGtmReferrer(domain: string) {
  return SHARED_PRODUCTION_ORIGINS.includes(domain);
}

/**
 * Cookie domain for the shared GTM campaign cookie.
 * www and business use the parent host so a visit on either site is visible to the other.
 */
export function gtmCookieDomain(domain: string) {
  if (domain.includes('localhost')) {
    return 'localhost';
  }

  try {
    const host = new URL(domain).hostname;
    if (SHARED_PRODUCTION_HOSTS.has(host)) {
      return SHARED_COOKIE_HOST;
    }
    return host;
  } catch {
    return domain;
  }
}
